import { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'

// Source: https://github.com/vinted/dwh-schema-registry/blob/806b6d40b4bfcd75377381aab0c608e5ee46e14e/avro/events/profile/click.avdl#L25
type ProfileClickTarget = 'user_short_info_cell' | 'user_short_info_cell'

type ProfileClickEventArgs = {
  target: ProfileClickTarget
  ownerId: string
  screen?: string
  itemId?: string
}

type ProfileClickEventExtra = {
  target: ProfileClickTarget
  owner_id: string
  screen?: string
  item_id?: string
}

export const profileClickEvent = (args: ProfileClickEventArgs): TrackingEvent => {
  const { target, ownerId, screen, itemId } = args

  const extra: ProfileClickEventExtra = { target, owner_id: ownerId }

  if (screen) extra.screen = screen
  if (itemId) extra.item_id = itemId

  return {
    event: 'profile.click',
    extra,
  }
}

// Source: https://github.com/vinted/dwh-schema-registry/blob/master/avro/events/user/view.avdl#L25
type ViewEventTarget = 'user_last_seen'

type ViewEventArgs = {
  target: ViewEventTarget
  targetDetails?: string
  screen?: string
}

type ViewEventExtra = {
  target: ViewEventTarget
  target_details?: string
  screen?: string
}

export const viewEvent = (args: ViewEventArgs): TrackingEvent => {
  const { target, targetDetails, screen } = args

  const extra: ViewEventExtra = {
    target,
  }

  if (targetDetails) extra.target_details = targetDetails
  if (screen) extra.screen = screen

  return {
    event: 'user.view',
    extra,
  }
}
